export enum GameMode {
  Fun,
  Real,
}

export const GameModeStringMap = {
  'fun': GameMode.Fun,
  'real': GameMode.Real,
};
